import { Button, Grid, Paper, Typography } from "@material-ui/core";
import LabelsContext from "../../../lang/LabelsContext";
import TicketDto from "../../../model/ticket/TicketDto";
import TicketsService, { TicketsServiceType } from "../../../service/tickets/TicketService";
import TicketCard from "./card/TicketCard";
import TicketDialog from "./dialog/TicketDialog";
import { useStyles } from "./TicketStyle";

export default function Tickets() {
  const { ticketList, open, setOpen, ticketSave, enumTicketTypeList, ticketDelete }: TicketsServiceType =
    TicketsService();
  const classes = useStyles();
  const { Labels } = LabelsContext();

  return (
    <>
      <TicketDialog open={open} setOpen={setOpen} ticketSave={ticketSave} enumTicketTypeList={enumTicketTypeList} />
      <Paper className={classes.paper}>
        <Typography component="h1" variant="h4" align="center">
          {Labels.TICKETS}
        </Typography>
        <Grid container direction="row" justifyContent="flex-start" spacing={2}>
          <Grid item xs={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              {Labels.NEW_TICKET}
            </Button>
          </Grid>
          <Grid item container xs={10} alignItems="center">
            <Typography align="left">{Labels.TICKET_HELP}</Typography>
          </Grid>
        </Grid>
        {ticketList && (
          <Grid container direction="row" justifyContent="flex-start" spacing={3}>
            {ticketList.map((ticket: TicketDto) => {
              return (
                <Grid item xs={3}>
                  <TicketCard
                    key={ticket.id}
                    status={ticket.status}
                    name={ticket.name}
                    id={ticket.id}
                    ticket={ticket}
                    ticketDelete={ticketDelete}
                    date={ticket.date}
                    type={ticket.type}
                  />
                </Grid>
              );
            })}
          </Grid>
        )}
      </Paper>
    </>
  );
}
